<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny">

            <template v-if="isV4">
                <BnFormField v-if="isSZGK() || isMKP()" key="partner" :attributes="partner"/>

                <BnFormField v-if="isSZGK()" key="extrapartner" :attributes="extrapartner"/>

                <BnFormField v-if="lakastkotokEngedelyezett" key="lakastkotok_kedvezmeny" :attributes="lakastkotokKedvezmeny"/>

                <BnFormField v-if="lakastkotokEngedelyezett && lakastkotokKert" key="lakastkotok_v4" :attributes="lakaskotok"/>
            </template>
            <template v-else>
                <BnFormField v-if="isSZGK()" :attributes="egyuttlakas"/>

                <BnFormField v-if="isSZGK()" :attributes="lakaspartner"/>

                <BnFormField v-if="isSZGK() || isMKP()" :attributes="egyuttcasco"/>

                <BnFormField v-if="isSZGK()" :attributes="egyuttelet"/>

                <BnFormField v-if="isSZGK()" :attributes="egyuttbaleset"/>

                <BnFormField v-if="isSZGK()" :attributes="vallvagyon"/>
            </template>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import { SZGK } from '../../../../../../../modules/Gepjarmu';

export default {
    name: 'KedvezmenyekB3',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
        egyuttlakasChange() {
            this.$store.commit('setProp', {
                value: false,
                path: 'kedvezmenyekbiztosito.3.lakaspartner',
            });
            this.shouldRecalc();
        },
        lakaspartnerChange() {
            this.$store.commit('setProp', {
                value: false,
                path: 'kedvezmenyekbiztosito.3.egyuttlakas',
            });
            this.shouldRecalc();
        },
        lakastkotokKedvezmenyChange() {
            if (!this.lakastkotokKert) {
                this.$store.commit('setProp', {
                    value: null,
                    path: 'kedvezmenyekbiztosito.3.lakastkotok',
                });
            }
            this.shouldRecalc();
        },
    },
    computed: {
      isV4() {
        return parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd, 10) >= 20261201;
      },
      partner() {
        return {
          type: 'select',
          label: 'Partner kedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.partner',
          mezo: 'aegon_partner',
          help: true,
          change: this.shouldRecalc,
          options: [
            { key: 'N', value: 'Nem kérem' },
            { key: 'E', value: 'Élet' },
            { key: 'B', value: 'Baleset' },
            { key: 'L', value: 'Lakás' },
            { key: 'C', value: 'Casco' },
            { key: 'V', value: 'Vállalati vagyon' },
          ],
          itemsText: 'value',
          itemsValue: 'key',
          clearable: false,
        };
      },
      extrapartner() {
        return {
          type: 'select',
          label: 'Extrapartner kedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.extrapartner',
          mezo: 'aegon_extrapartner',
          help: true,
          change: this.shouldRecalc,
          options: [
            { key: 'N', value: 'Nem kérem' },
            { key: 'E', value: 'Élet' },
            { key: 'B', value: 'Baleset' },
            { key: 'L', value: 'Lakás' },
          ],
          itemsText: 'value',
          itemsValue: 'key',
          clearable: false,
        };
      },
      lakastkotokKedvezmeny() {
        return {
          type: 'select',
          label: 'Lakásbiztosítást fogok kötni kedvezmény',
          visible: true,
          editable: !this.disabled && this.lakastkotokEngedelyezett,
          path: 'kedvezmenyekbiztosito.3.lakastkotok_kedvezmeny',
          mezo: 'aegon_lakastkotok_kedvezmeny',
          help: true,
          change: this.lakastkotokKedvezmenyChange,
          options: [
            { key: 'N', value: 'Nem kérem' },
            { key: 'Y', value: 'Kérem' },
          ],
          itemsText: 'value',
          itemsValue: 'key',
          clearable: false,
        };
      },
      lakastkotokKert() {
        return this.getValue('kedvezmenyekbiztosito.3.lakastkotok_kedvezmeny') === 'Y';
      },
      egyuttlakas() {
        return {
          type: 'checkbox',
          label: 'Lakásbiztosítás együttkötési kedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.egyuttlakas',
          mezo: 'aegon_egyuttlakas',
          help: true,
          change: this.egyuttlakasChange,
        };
      },
      lakaspartner() {
        return {
          type: 'checkbox',
          label: 'Lakás partnerkedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.lakaspartner',
          mezo: 'lakaspartner',
          help: true,
          change: this.lakaspartnerChange,
        };
      },
      egyuttbaleset() {
        return {
          type: 'checkbox',
          label: 'Balesetbiztosítási együttkötési kedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.egyuttbaleset',
          mezo: 'aegon_egyuttbaleset',
          help: true,
          change: this.shouldRecalc,
        };
      },
      egyuttcasco() {
        return {
          type: 'checkbox',
          label: 'CASCO együttkötési kedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.egyuttcasco',
          mezo: 'aegon_egyuttcasco',
          help: true,
          change: this.shouldRecalc,
        };
      },
      egyuttelet() {
        return {
          type: 'checkbox',
          label: 'Életbiztosítási együttkötési kedvezmény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.egyuttelet',
          mezo: 'aegon_egyuttelet',
          help: true,
          change: this.shouldRecalc,
        };
      },
      vallvagyon() {
        return {
          type: 'checkbox',
          label: 'Vállalati vagyon együttk. kedvemény',
          visible: true,
          editable: this.egyebKedvezmenyekEditable,
          path: 'kedvezmenyekbiztosito.3.vallvagyon',
          mezo: 'aegon_vallvagyon',
          help: true,
          change: this.shouldRecalc,
        };
      },
      egyebKedvezmenyekEditable() {
        return !this.disabled && (this.isV4 || !this.lakastkotokMegadva);
      },
      lakastkotokMegadva() {
        const value = this.getValue('kedvezmenyekbiztosito.3.lakastkotok');

        return value !== null && typeof value !== 'undefined' && String(value).trim() !== '';
      },
      lakaskotok() {
        return {
          type: 'text',
          label: 'Lakás m²',
          visible: true,
          editable: !this.disabled && this.lakastkotokEngedelyezett,
          path: 'kedvezmenyekbiztosito.3.lakastkotok',
          mezo: 'lakastkotok',
          help: true,
          change: this.shouldRecalc,
          mask: 'XXX',
        };
      },
      lakastkotokEngedelyezett() {
        return this.$store.getters.tarifaData.ajanl_vehicle_use === 1 && this.isSZGK();
      }
    },
    data() {
        return {
            SZGK,
            aegon_60km: {
                type: 'select',
                label: 'Ingázók korrekció',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekalaptabla.3.aegon_60km',
                mezo: '_aegon_aegon_60km',
                help: true,
                change: this.shouldRecalc,
                options: [
                    { key: 'N', value: 'Nem' },
                    {
                        key: 'Y',
                        value: 'Igen, a munkahely legfeljebb 60 km-re van az életvitel szerinti tartózkodási helyétől',
                    },
                    {
                        key: 'Y60',
                        value: 'Igen, a munkahely 60 km-nél messzebb van az életvitel szerinti tartózkodási helyétől',
                    },
                ],
                itemsText: 'value',
                itemsValue: 'key',
            },
        };
    },
};
</script>
